import { useEffect, useState } from "react";
import "./App.css";
import "./chartSetup";
import { AuthProvider } from "./context/AuthContext";
import { AppContent } from "./AppContent";

const AUTH_PATHS = { login: '/login', register: '/registro' };

const initialAuthMode = () => {
  const path = window.location.pathname.replace(/\/+$/, '');
  return Object.keys(AUTH_PATHS).find(mode => AUTH_PATHS[mode] === path) || 'landing';
};

// Main App Component
function App() {
  const [authMode, setAuthModeState] = useState(initialAuthMode);
  // Keep the address bar in sync so /login and /registro can be shared and bookmarked
  const setAuthMode = (mode) => {
    setAuthModeState(mode);
    const path = AUTH_PATHS[mode] || '/';
    if (Object.values(AUTH_PATHS).concat('/').includes(window.location.pathname) && window.location.pathname !== path) {
      window.history.pushState(null, '', path);
    }
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    const onBack = () => setAuthModeState(initialAuthMode());
    window.addEventListener('popstate', onBack);
    return () => window.removeEventListener('popstate', onBack);
  }, []);

  return (
    <AuthProvider>
      <div className="App">
        <AppContent authMode={authMode} setAuthMode={setAuthMode} />
      </div>
    </AuthProvider>
  );
}


export default App;
